import { UseInfiniteQueryOptions } from '@tanstack/react-query';
import { ApiModel, BulkUploadDraftModelConverter, BulkUploadMyDraftModel } from '@steelbuy/ts-shared';
import { ResponseModel } from '../../utils/types';
import { usePaginatedQuery } from '../../utils/usePaginatedQuery';

export const MY_BULK_LISTING_DRAFTS_KEY = 'bulk-listings-drafts';

const modelConverter = new BulkUploadDraftModelConverter();
const searchListingMapFn = (data: BulkUploadMyDraftModel) =>
    modelConverter.toViewModel(data as unknown as ApiModel<BulkUploadMyDraftModel>);

export const useMyBulkListingDrafts = ({
    queryOptions,
}: {
    queryOptions?: Omit<
        UseInfiniteQueryOptions<ResponseModel<BulkUploadMyDraftModel[]>>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >;
}) =>
    usePaginatedQuery<BulkUploadMyDraftModel>({
        url: '/api/universal/bulk-listing-drafts',
        requestOptions: {},
        mapFn: searchListingMapFn,
        queryKey: [MY_BULK_LISTING_DRAFTS_KEY],

        queryOptions: {
            ...queryOptions,
            cacheTime: 0,
        },
    });
